import {AfterViewInit, Component, OnInit, ViewEncapsulation,} from '@angular/core';
import {TweenMax, Power2, TimelineLite} from 'gsap';
import Popper from 'popper.js';
import Tooltip from 'tooltip.js';
import {WebNavigationService} from './navigation.service';
import {AuthService} from "../../core/auth/auth.service";
import {LocalStorageService} from "../../core/storage/storage.service";
declare var $;
@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NavigationComponent implements OnInit, AfterViewInit {

  private popper;
  private timer;
  private dashboardTooltip;
  private reglasTooltip;
  private conciliacionTooltip;
  private anotherPopper;
  private pronosticosTooltip;
  private promocionesTooltip: any;

  constructor(public navigationService: WebNavigationService,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.navigationService.doExpand();
    this.reactToToggle();
  }

  ngAfterViewInit(): void {
    const reference = $('#payments-btn');
    this.popper = $('#tree-payments-options-collapsed');
    this.anotherPopper = new Popper(
      reference,
      this.popper,
      {
        placement: 'right'
      }
    );
    $('#payments-btn, #tree-payments-options-collapsed').hover(() => {
      if (!this.navigationService.expanded) {
        clearTimeout(this.timer);
        this.anotherPopper.update();
        this.popper.addClass('display');
      }
    }, () => {
      this.timer = setTimeout(() => {
        if (!this.navigationService.expanded) {
          this.popper.removeClass('display');
        }
      }, 200);
    });

  }


  get userName() {
    return this.authService.decodedJwtToken.user_name;
  }

  private createTooltips() {
    this.dashboardTooltip = new Tooltip($('#dashboard-option'), {
      placement: 'right',
      title: 'Dashboard',
      trigger: 'hover'
    });

    this.reglasTooltip = new Tooltip($('#reglas-option'), {
      placement: 'right',
      title: 'Reglas Negocio',
      trigger: 'hover'
    });

    this.conciliacionTooltip = new Tooltip($('#conciliacion-option'), {
      placement: 'right',
      title: 'Conciliación',
      trigger: 'hover'
    });

    this.pronosticosTooltip = new Tooltip($('#pronosticos-option'), {
      placement: 'right',
      title: 'Pronósticos',
      trigger: 'hover'
    });
    this.promocionesTooltip = new Tooltip($('#promociones-option'), {
      placement: 'right',
      title: 'Promociones',
      trigger: 'hover'
    });

  }

  private destroyTooltips() {
    if (this.dashboardTooltip) {
      this.dashboardTooltip.dispose();
    }
    if (this.reglasTooltip) {
      this.reglasTooltip.dispose();
    }
    if (this.conciliacionTooltip) {
      this.conciliacionTooltip.dispose();
    }
    if (this.pronosticosTooltip) {
      this.pronosticosTooltip.dispose();
    }
    if (this.promocionesTooltip) {
      this.promocionesTooltip.dispose();
    }
  }

  toggle() {
    this.navigationService.toggle();
    this.reactToToggle();
  }

  private reactToToggle() {
    if (this.navigationService.expanded) {
      TweenMax.to('nav', 0.1, {'width': '250px'});
      TweenMax.to('.welcome-message', 0.1, {'font-size': '1rem'});
      this.destroyTooltips();
    } else {
      TweenMax.to('nav', 0.1, {'width': '50px'});
      TweenMax.to('.welcome-message', 0.1, {'font-size': '0.7rem'});
      this.createTooltips();
    }
  }

  selectOption(option) {
    this.navigationService.selectOption(option);
  }

  get selectedOption() {
    return this.navigationService.selectedOption;
  }

  get expanded() {
    return this.navigationService.expanded;
  }

  signOut() {
    this.authService.signOut();
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/navigation/navigation.component.ts